import { useState } from "react";

import { Modal } from "@similarweb/ui-components";

import { swSettings } from "app/common/services/swSettings";
import {
    type ChangeSolutionStepsType,
    changeSolutionSteps,
    switchPopupClassName,
} from "app/components/ChangeSolutionModal/consts";

import { ChangeSolutionFlow } from "./ChangeSolutionFlow";
import { ChangeSolutionModalFooter } from "./ChangeSolutionModalFooter";
import { CHANGE_SOLUTION_STEPS, changeSolutionModalStyled } from "./config/changeSolutionSteps";
import { useChangeSolutionFlow } from "./hooks/useChangeSolutionFlow";
import { getDefaultSolution } from "./hooks/utils";
import { StyledModalContent, StyledOnboardingModal } from "./styles";
import type { IUseCaseStepConfig } from "./types";

export interface IOnboardingModalProps {
    isOpen: boolean;
    onClose: () => void;
}

export const ChangeSolutionModal = ({ isOpen, onClose }: IOnboardingModalProps) => {
    const [currentStep, setCurrentStep] = useState<ChangeSolutionStepsType>(changeSolutionSteps.welcome);
    const [selectedSolution, setSelectedSolution] = useState<IUseCaseStepConfig>();

    const defaultSolution = getDefaultSolution(swSettings);
    const currentStepConfig = CHANGE_SOLUTION_STEPS[currentStep];

    const { handleNext, handleBack, handleComplete, handleClose, isSwitchingSolution, switchSolutionError } =
        useChangeSolutionFlow({
            currentStep,
            steps: CHANGE_SOLUTION_STEPS,
            selectedSolution,
            defaultSolution,
            setCurrentStep,
            onClose,
            trackingEventName: currentStepConfig.trackingEventName,
        });

    return (
        <Modal
            isOpen={isOpen}
            shouldCloseOnOverlayClick={false}
            customStyles={changeSolutionModalStyled}
            data-automation="change-solution-modal"
        >
            <div>
                <StyledOnboardingModal className={switchPopupClassName}>
                    <StyledModalContent>
                        <ChangeSolutionFlow
                            selectedSolution={selectedSolution}
                            onSelectedSolutionChange={setSelectedSolution}
                            defaultSolution={defaultSolution}
                            currentStepConfig={currentStepConfig}
                        />
                    </StyledModalContent>

                    <ChangeSolutionModalFooter
                        currentStep={currentStep}
                        currentStepConfig={currentStepConfig}
                        onBack={handleBack}
                        onNext={handleNext}
                        handleClose={handleClose}
                        onComplete={handleComplete}
                        selectedSolution={selectedSolution}
                        isSwitchingSolution={isSwitchingSolution}
                        switchSolutionError={switchSolutionError}
                        trackingEventName={currentStepConfig.trackingEventName}
                    />
                </StyledOnboardingModal>
            </div>
        </Modal>
    );
};
